'use client';

import { Typography } from 'components';
import { AiStep, AiSubStepTypeEnum } from 'gql/graphql';
import { labelHelper } from 'helpers/labelHelper';
import useOptionsGlossaries from 'hooks/useOptionsGlossaries';
import useOptionsStyleGuides from 'hooks/useOptionsStyleGuides';
import { GlossaryStepIcon, StyleGuideStepIcon } from 'lib/svgs/StepsIcons';
import { useTranslations } from 'next-intl';
import { FC, PropsWithChildren } from 'react';
import { cn } from 'utils/cn';

const ResourcesSubStepsRun: FC<PropsWithChildren<Pick<AiStep, 'subSteps'>>> = ({ subSteps }) => {
  const t = useTranslations();

  const subStepStyleGuide = subSteps?.find(
    (subStep) => subStep.type === AiSubStepTypeEnum.StyleGuide
  );

  const subStepGlossary = subSteps?.find((subStep) => subStep.type === AiSubStepTypeEnum.Glossary);

  const { optionsGlossaries } = useOptionsGlossaries();
  const { optionsStyleGuides } = useOptionsStyleGuides({ attribute: 'id' });

  const styleGuideLabel = optionsStyleGuides?.find(
    (option) => option.value === subStepStyleGuide?.sourceId
  )?.label;

  const glossaryLabel = optionsGlossaries?.find(
    (option) => option.value === subStepGlossary?.sourceId
  )?.label;

  return (
    <>
      {(styleGuideLabel || glossaryLabel) && (
        <div className="flex flex-col gap-2 pt-2">
          <Typography variant="regular5" className="w-4/5 text-tertiary-200">
            {t('labels.context_resources')}:
          </Typography>
          <span className="flex flex-wrap justify-start gap-2">
            {styleGuideLabel && (
              <span
                className={cn(
                  'flex h-6 flex-row items-center gap-2 rounded-10xl pl-1 pr-2 outline-none',
                  '!bg-primary-blue-900 px-2'
                )}
              >
                <StyleGuideStepIcon className="scale-[0.8] !text-primary-blue-100" />
                <Typography variant="regular5" className="select-none text-primary-blue-100">
                  {labelHelper(styleGuideLabel)}
                </Typography>
              </span>
            )}
            {glossaryLabel && (
              <span
                className={cn(
                  'flex h-6 flex-row items-center gap-2 rounded-10xl pl-1 pr-2 outline-none',
                  '!bg-primary-blue-900 px-2'
                )}
              >
                <GlossaryStepIcon className="scale-[0.8] !text-primary-blue-100" />
                <Typography variant="regular5" className="select-none text-primary-blue-100">
                  {labelHelper(glossaryLabel)}
                </Typography>
              </span>
            )}
          </span>
        </div>
      )}
    </>
  );
};

export default ResourcesSubStepsRun;
